import { FC } from 'react';
import styles from './TriStateCheckbox.module.scss';
import cn from 'classnames';

type CheckboxValue = boolean | 'indeterminate';

const nextValue = (value: CheckboxValue = false): boolean => {
  if (value === 'indeterminate') {
    return true;
  }
  return !value;
};

type TriStateCheckboxProps = {
  checked?: CheckboxValue;
  disabled?: boolean;
  onChange: (value: boolean, previous: CheckboxValue, shiftKey: boolean) => void;
  onBlur?: () => void;
};

export const TriStateCheckbox: FC<TriStateCheckboxProps> = ({
  checked = false,
  disabled = false,
  onChange,
  onBlur,
}) => {
  const handleClick = (event: React.MouseEvent | React.KeyboardEvent) => {
    if (!disabled) {
      onChange(nextValue(checked), checked, event.shiftKey);
    }
  };
  return (
    <div
      className={cn(styles.Container, {
        [styles.unchecked]: checked === false,
        [styles.checked]: checked === true,
        [styles.indeterminate]: checked === 'indeterminate',
        [styles.disabled]: disabled,
      })}
      onClick={handleClick}
      onMouseDown={(e) => {
        if (e.shiftKey) {
          e.preventDefault();
        }
      }}
      onBlur={onBlur}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          handleClick(e);
        }
      }}
      role="checkbox"
      tabIndex={disabled ? -1 : 0}
      data-test-component="TriStateCheckbox"
      data-test-element="checkbox"
    />
  );
};
